export { default as apexConfig } from './apexConfig';
export { default as skuSchema } from './skuSchema';
export { default as colors } from './colors';
export { default as paginationOptions } from './paginationOptions';
export * from './eventTypeMap';
export * from './dataSourceMap';
export type { SearchFlowsParams } from './flows';
export * from './processingStatusMap';
export * from './sourceOptions';
export * from './sidebarModes';
export * from './serviceKeys';
export * from './usageRecompilation';

export const systemDateFormat = 'YYYY-MM-DD';
export const requestsRateLimit = 5;
export const chartDefaultHeight = 412;
export const chartCompactHeight = 150;

export enum Client {
  OPS = 'ops',
}

export enum Env {
  PROD = 'prod',
  DEV = 'dev',
}

export enum CustomerStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended',
  DELETED = 'deleted',
  TRIAL = 'trial',
}

export enum DataBillableType {
  ALL = 'all',
  BILLABLE = 'billable',
  NOT_BILLABLE = 'not_billable',
}

export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
}

export enum GroupTraffic {
  ACCOUNT = 'account_id',
  ENVIRONMENT = 'environment_id',
  SKU = 'sku_fragment',
  FLOW = 'flow_id',
  NO_GROUPING = 'no_grouping',
}
